import { ComponentProps } from 'react';
import Col from 'antd/es/col';
import clsx from 'clsx';

interface OpColProps extends ComponentProps<typeof Col> {
  testId?: string;
}

/**
 * OpCol is a wrapper around Ant Design's Col (Column) component.
 * It provides a column layout component for use with OpRow to create responsive grid layouts.
 * 
 * Use this component inside OpRow to create flexible, responsive column-based layouts.
 * Supports responsive breakpoints (xs, sm, md, lg, xl, xxl) for different screen sizes.
 * 
 * @example
 * <OpRow>
 *   <OpCol span={12}>Half width column</OpCol>
 *   <OpCol span={12}>Half width column</OpCol>
 * </OpRow>
 * 
 */
export const OpCol = ({
  className,
  testId = 'op-col',
  ...colProps
}: OpColProps) => {
  return (
    <Col
      className={clsx('op-col', className)}
      data-testid={testId}
      {...colProps}
    />
  );
};
